export const loginConfig = {
  sections: [
    {
      title: "Sign In",
      fields: [
        {
          type: "text",
          name: "mobileno",
          label: "Mobile Number",
          required: true,
        },
        {
          type: "password",
          name: "password",
          label: "Password",
          required: true,
        },
      ],
    },
  ],
};
